// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fqyl","select":"styles_select__14RB3"};